import React from 'react';

import { CARD_THEMES } from './card_theme';
import { ToolCard } from './link_card';

import type { AddContactsToListToolCall, ContactListCardMetadata } from '../types';

interface ContactListCardsProps {
  toolCalls: AddContactsToListToolCall[];
}

function getLists(toolCalls: ContactListCardsProps['toolCalls']) {
  const byPath = new Map<string, ContactListCardMetadata>();
  toolCalls.forEach(({ metadata }) => {
    if (metadata.list) byPath.set(metadata.list.path, metadata.list);
  });

  return [...byPath.values()];
}

export function ContactListCards({ toolCalls }: ContactListCardsProps) {
  return (
    <>
      {getLists(toolCalls).map(list => (
        <ToolCard href={list.path} key={list.path} theme={CARD_THEMES.contactList}>
          <div className="fw-semibold text-truncate">{list.name}</div>
          <div className="small text-muted text-truncate">View the contact list</div>
        </ToolCard>
      ))}
    </>
  );
}
